import { shallowEqual } from 'react-redux';

import accessUtils from '../../utils/accessUtils';
import { useSelector } from '../../selectors/useSelector';

import PropertiesPage from '../PropertiesPage';
import { ZRAMPropertiesPage } from '../ZRAMPropertiesPage';

const PropertiesPageWrapper = () => {
  const { cookieEnabledServices, canAccessZramMultifamilyPropertyTable } = useSelector(
    (state) => ({
      cookieEnabledServices: state.app.cookieEnabledServices,
      canAccessZramMultifamilyPropertyTable: state.user.canAccessZramMultifamilyPropertyTable,
    }),
    shallowEqual,
  );

  const canAccessListingQuality = accessUtils.canAccessListingQuality({
    cookieEnabledServices,
    canAccessZramMultifamilyPropertyTable,
  });

  if (canAccessListingQuality) {
    return <ZRAMPropertiesPage />;
  }

  return <PropertiesPage />;
};

export default PropertiesPageWrapper;
